import type { ApiEffect } from '../../index.h'

import { createEffect } from 'effector'

//POST /v3/device/push_token
export const pushTokenFx: ApiEffect<string, void> = createEffect()
